const { protocol, hostname, host } = window.location;

const isHttps = protocol === 'https:';
const baseProtocol = isHttps ? 'https' : 'http';
const wsProtocol = isHttps ? 'wss' : 'ws';

const {
  REACT_APP_BASE_URL_PORT,
  REACT_APP_SOCKET_URL_PORT,
  REACT_APP_WSS_URL_PORT,
  REACT_APP_PDF_URL_PORT,
  REACT_APP_BASE_URL,
  REACT_APP_SOCKET_URL,
  REACT_APP_WSS_URL,
  REACT_APP_IS_DYNAMIC_URL,
  REACT_APP_USE_PATH_ROUTING
} = process.env;

const isDynamic = REACT_APP_IS_DYNAMIC_URL === 'true';

// Same-origin mode: browser talks only to the page's own origin (port 80/443).
// nginx routes /api/ -> :3300, /socket.io/ -> :3301, /fsws -> FreeSWITCH WS.
// Set REACT_APP_USE_PATH_ROUTING='false' to fall back to port-based URLs.
const isPathRouting = REACT_APP_USE_PATH_ROUTING === 'true';

const buildUrl = (proto, port) => `${proto}://${hostname}:${port}`;

const buildPdfUrlFromBase = () => {
  try {
    const baseUrl = isDynamic
      ? `${buildUrl(baseProtocol, REACT_APP_BASE_URL_PORT)}/`
      : REACT_APP_BASE_URL;
    const url = new URL(baseUrl);
    url.port = REACT_APP_PDF_URL_PORT;
    return `${url.origin}/`;
  } catch (e) {
    console.error('Invalid BASE_URL:', e.message);
    return '';
  }
};

const config = isPathRouting
  ? {
      BASE_URL: `${baseProtocol}://${host}/api/`,
      SOCKET_URL: `${baseProtocol}://${host}/`,
      WSS_URL: `${wsProtocol}://${host}/fsws`,
      PDF_BASE_URL: buildPdfUrlFromBase()
    }
  : {
      BASE_URL: isDynamic
        ? `${buildUrl(baseProtocol, REACT_APP_BASE_URL_PORT)}/`
        : REACT_APP_BASE_URL,
      SOCKET_URL: isDynamic
        ? `${buildUrl(baseProtocol, REACT_APP_SOCKET_URL_PORT)}/`
        : REACT_APP_SOCKET_URL,
      WSS_URL: isDynamic ? buildUrl(wsProtocol, REACT_APP_WSS_URL_PORT) : REACT_APP_WSS_URL,
      PDF_BASE_URL: buildPdfUrlFromBase()
    };

export default config;
